import { ChangeDetectionStrategy, ChangeDetectorRef, Component, Input, OnDestroy, OnInit, ViewEncapsulation } from '@angular/core';
import { Router, NavigationStart } from '@angular/router';
import { BooleanInput } from '@angular/cdk/coercion';
import { MatDialog } from '@angular/material/dialog';
import { Subject } from 'rxjs';
import { takeUntil } from 'rxjs/operators';
import { User } from 'app/core/user/user.types';
import { UserService } from 'app/core/user/user.service';
import { AngularFirestore } from '@angular/fire/compat/firestore';
import { EditProfileComponent } from './edit-profile/edit-profile.component';

@Component({
    selector       : 'user',
    templateUrl    : './user.component.html',
    encapsulation  : ViewEncapsulation.None,
    changeDetection: ChangeDetectionStrategy.OnPush,
    exportAs       : 'user'
})
export class UserComponent implements OnInit, OnDestroy
{
    /* eslint-disable @typescript-eslint/naming-convention */
    static ngAcceptInputType_showAvatar: BooleanInput;
    /* eslint-enable @typescript-eslint/naming-convention */

    @Input() showAvatar: boolean = true;
    user: User;
    userManageView: boolean = false;
    userNotifyView: boolean = false;
    userSystemAssign: boolean = false;
    bulletinManagement: boolean = false;

    private _unsubscribeAll: Subject<void> = new Subject<void>();

    /**
     * Constructor
     */
    constructor(
        private _changeDetectorRef: ChangeDetectorRef,
        private _router: Router,
        private _userService: UserService,
        private _matDialog: MatDialog,
        private angularFirestore: AngularFirestore
    )
    {}

    // -----------------------------------------------------------------------------------------------------
    // @ Lifecycle hooks
    // -----------------------------------------------------------------------------------------------------

    /**
     * On init
     */
    ngOnInit(): void
    {
        // Subscribe to user changes
        this._userService.user$
            .pipe(takeUntil(this._unsubscribeAll))
            .subscribe((user: User) => {
                this.user = user;
                //console.log(this.user)

                if(!this.user){
                    const user = JSON.parse(sessionStorage.getItem('user'));
                    //console.log(user)

                    if (user){
                        this.user = user
                    }
                }

                const permRef = this.angularFirestore.firestore.collection('permissions')
                //const permRef = collection(this.angularFirestore, 'permissions')
        
                permRef.get().then(snap => {
                    snap.forEach(document => {
                        if(document.id === this.user.organization){
                            for(var ii in document.data()){
                                if(ii === this.user['role']){
                                    this.userManageView = document.data()[ii]['menu'][1]['user_management']
                                    this.userNotifyView = document.data()[ii]['menu'][1]['user_notify']
                                    this.userSystemAssign = document.data()[ii]['menu'][1]['user_sys_assign']
                                    this.bulletinManagement = document.data()[ii]['menu'][1]['bulletin_management'] ?? false
                                }
                            }
                        }
                    })
                })


                // Mark for check
                this._changeDetectorRef.detectChanges();
            },error=>{
            });

        if(!this.user){
            const user = JSON.parse(sessionStorage.getItem('user'));
            //console.log(user)
            if (user){
                this.user = user
            }
        }
    }

    /**
     * On destroy
     */
    ngOnDestroy(): void
    {
        // Unsubscribe from all subscriptions
        this._unsubscribeAll.next();
        this._unsubscribeAll.complete();
    }

    // -----------------------------------------------------------------------------------------------------
    // @ Public methods
    // -----------------------------------------------------------------------------------------------------

    /**
     * Update the user status
     *
     * @param status
     */
    updateUserStatus(status: string): void
    {
        // Return if user is not available
        if ( !this.user )
        {
            return;
        }

        // Update the user
        this._userService.update({
            ...this.user,
            status
        }).subscribe();
    }

    /**
     * Sign out
     */
    signOut(): void
    {
        this._router.navigate(['/sign-out']);
    }

    userManagement(): void
    {
        this._router.navigate(['/user-management'])
    }

    editProfile(): void
    {
        this._matDialog.open(EditProfileComponent, {
            data: { user: this.user },
            autoFocus: false,
            width: '540px',
            maxWidth: '94vw',
            panelClass: 'edit-profile-dialog-panel'
        });
    }

    systemAssignment(): void
    {
        this._router.navigate(['/system-assignment'])
    }

    setNotifications(): void
    {
        this._router.navigate(['/notifications'])
    }

    bulletinMangement(): void
    {
        this._router.navigate(['/bulletin-management'])
    }
 
}
